// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-form {
  background-color: var(--registration-form-bg-color);
}
.registration-form__submit-button {
  background-color: var(--registration-form-button-bg-color) !important;
  color: var(--registration-form-button-color) !important;
  border-color: var(--registration-form-button-border-color) !important;
}
.registration-form__submit-button:hover {
  background-color: var(--registration-form-button-bg-color-hover) !important;
  color: var(--registration-form-button-color-hover) !important;
  border-color: var(--registration-form-button-border-color-hover) !important;
}
.registration-form__footer {
  margin-bottom: 20px;
  font-size: var(--registration-form-footer-font-size);
}
.registration-form__intro {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2rem;
}
.registration-form__another-content {
  margin-top: 1rem;
  cursor: pointer;
}
.registration-form__closed {
  margin-top: 0.5rem;
}
.registration-form__required-helper {
  padding-bottom: 20px;
}
.registration-form--no-background {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/RegistrationForm/RegistrationForm.scss"],"names":[],"mappings":"AAAA;EACI,mDAAA;AACJ;AACI;EACI,qEAAA;EACA,uDAAA;EACA,qEAAA;AACR;AACQ;EACI,2EAAA;EACA,6DAAA;EACA,2EAAA;AACZ;AAGI;EACI,mBAAA;EACA,oDAAA;AADR;AAII;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFR;AAKI;EACI,gBAAA;EACA,eAAA;AAHR;AAMI;EACI,kBAAA;AAJR;AAOI;EACI,oBAAA;AALR;AAQI;EACI,6BAAA;AANR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
